import { FC } from "react";
import { Typography } from "@mui/material";

const TooltipDirectionContent: FC = () => {
  return (
    <Typography sx={{ fontSize: 10 }} variant="body2" color="textSecondary">
      If you believe that the asset will rise, then open a “
      <span style={{ color: "#04D538", fontSize: 12, fontWeight: "bold" }}>Long</span>” bot, such a
      bot will have an asset at 100% of the allocated amount at the lower boundary of the range and
      0% of the asset at the upper boundary of the range
      <br></br>
      <br></br>
      If you believe the asset will fall, then open a “
      <span style={{ color: "#EF4444", fontSize: 12, fontWeight: "bold" }}>Short</span>” bot, such a
      bot will have an open position on the downside at 100% of the allocated amount on the upper
      boundary of the range and 0% of the position on the lower boundary of the range.
      <br></br>
      <br></br>“<span style={{ fontSize: 12, fontWeight: "bold" }}>Central</span>” bot will have a
      0% position in the center of the range, 50% of the allocated amount on the upper boundary of
      the range and 50% on the lower boundary.
    </Typography>
  );
};

export default TooltipDirectionContent;
